// Ticket metadata (price + key + visual flags). Localized text lives in /events/bizcon-warszawa/i18n.js
export const META = {
  slug: "bizcon-warszawa",
  title: "Business Conf · Warsaw",
  domain: "bizcon.voxianet.com",
  contactWebhookUrl: process.env.REACT_APP_N8N_CONTACT_WEBHOOK || "https://automation.voxianet.com/webhook/bizcon-contact",
  turnstileAction: "bizcon_contact",
};

export const TICKETS = [
  { key: "standard", icon: "🎟", price: 160, highlight: false, soldOut: true, hidden: true },
  { key: "mini_partner", icon: "✨", price: 200, highlight: true, badgeKey: "popular", soldOut: true, hidden: true },
  { key: "speaker", icon: "🎤", price: 180, highlight: false, soldOut: true, hidden: true },
  { key: "conference_partner", icon: "🤝", price: 350, highlight: true, badgeKey: "premium", soldOut: true, hidden: true },
  { key: "afterparty", icon: "🎟", price: 100, highlight: false, soldOut: true },
  { key: "bizcon_fuckup", icon: "🎭", price: 165, highlight: true, badgeKey: "combo", soldOut: true, hidden: true },
  { key: "brunch_afterparty", icon: "🥂", price: 150, highlight: false, soldOut: true, hidden: true },
  { key: "brunch_speakers", icon: "☕", price: 50, highlight: false, soldOut: true },
];

export const SPEAKER_PHOTOS = [
  "/events/bizcon-warszawa/speakers/wiktor.jpeg",
  "/events/bizcon-warszawa/speakers/renata.jpeg",
  "/events/bizcon-warszawa/speakers/Dina.jpeg",
  "/events/bizcon-warszawa/speakers/Julia.jpeg",
  "/events/bizcon-warszawa/speakers/pawel.jpeg",
  "/events/bizcon-warszawa/speakers/alesia.jpeg",
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1675716921224-e087a0cca69a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMG5ldHdvcmtpbmclMjBldmVudCUyMGF0bW9zcGhlcmV8ZW58MHx8fHwxNzc5NzA2MDQ5fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1515168833906-d2a3b82b302a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMG5ldHdvcmtpbmclMjBldmVudCUyMGF0bW9zcGhlcmV8ZW58MHx8fHwxNzc5NzA2MDQ5fDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1531058020387-3be344556be6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMG5ldHdvcmtpbmclMjBldmVudCUyMGF0bW9zcGhlcmV8ZW58MHx8fHwxNzc5NzA2MDQ5fDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/8761636/pexels-photo-8761636.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80",
];

export const HERO_IMG =
  "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=85";

export const PARTNERS = ["FORVIA", "NEXUS", "ATELIER", "ORION", "STELLAR", "MERIDIAN", "VERTEX", "AURUM"];
